import { values } from 'lodash';

import { SchemaField } from '../../../legacy/objects/generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../../legacy/objects/generic/serialization/serializable-object-schema';
import { SessionURL } from '../../core/session-url/session-url';

import { ExperienceTriggerEnableIf } from './experience-trigger-enable-if';

export class ExperienceTriggerSchema extends SerializableObjectSchema {
  public static readonly firstClick = 'firstClick';
  public static readonly enableIf = 'enableIf';
  public static readonly keywords = 'keywords';
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters: { [key: string]: import('joi').AnySchema } = {};

    parameters[ExperienceTriggerSchema.firstClick] = SchemaField.obj(SessionURL, undefined).optional();
    parameters[ExperienceTriggerSchema.enableIf] = SchemaField.string(undefined)
      .valid(...values(ExperienceTriggerEnableIf))
      .required();
    parameters[ExperienceTriggerSchema.keywords] = SchemaField.arrayOfType(
      SchemaField.string(undefined),
      undefined,
    ).optional();

    return parameters;
  }
}
